import { render, staticRenderFns } from "./WebseiteAnmeldungInfoveranstaltung.vue?vue&type=template&id=3636c55e"
import script from "./WebseiteAnmeldungInfoveranstaltung.vue?vue&type=script&lang=js"
export * from "./WebseiteAnmeldungInfoveranstaltung.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports